"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tooltip_1 = require("../../../core/tooltip");
function calcProgressTimeTooltipCenterX(progressPercent, progressNodeOffsetX, progressNodeWidth) {
    return progressNodeOffsetX + progressPercent * progressNodeWidth / 100;
}
function getProgressTimeTooltipPosition(progressPercent, progressNode, tooltipContainerNode) {
    return tooltip_1.getTooltipPositionByReferenceNode(progressNode, tooltipContainerNode, function (progressNodeOffsetX, progressNodeWidth) {
        return calcProgressTimeTooltipCenterX(progressPercent, progressNodeOffsetX, progressNodeWidth);
    });
}
exports.default = getProgressTimeTooltipPosition;
//# sourceMappingURL=getProgressTimeTooltipPosition.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/playable/dist/src/modules/ui/controls/progress/utils/getProgressTimeTooltipPosition.js
// module id = 160
// module chunks = 0